import { useEffect, useState } from "react";
import Common from "../../helper/common";
import { Button } from "../../components/ui/button";
import { Icon } from "@iconify/react";
import AdvanceTable from "../../components/advanceTable";

import AddBookingCancellationReason from "./create";
import { BookingCancellationReasonTypeEnum } from "../../constants/appConstant";

const BookingCancellationReasons = () => {

  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);


  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open, refId]);

  useEffect(() => {
    getData();

  }, [

  ]);

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
   

    const response = await Common.ApiService.getInstance().request(
      "GetBookingCancellationReasonsList",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: true,
        recordsToDisplay,
      },

      "Post"
    );

    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          reason_type:item.reason_type? Common.Utility.getKeyByValue(BookingCancellationReasonTypeEnum,item.reason_type):"-",
          is_other:item.is_other ? "True":"False",

        })),
      };

      setData(obj);
    }
  };

  const columns = [
   
    { title: "Reason", type: "text", isVisible: true, key: "reason" },
    { title: "Reason Type", type: "text", isVisible: true, key: "reason_type" },
    { title: "Is Other", type: "text", isVisible: true, key: "is_other" },
   
    
  ];

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure want to delete this Booking Cancellation Reason??",
      "Delete Cancellation Reason"
    );

    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteBookingCancellationReason?id=${id}`,
        {},
        "Delete"
      );

      Common.SweetAlert.alert(resp.message, "success");

      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };

  const _addUpdateTrigger = () => {
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>;
  };

  return (
    <>

      {data?.data && (
        <AdvanceTable
          title={"Cancellation Reasons"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={() => (
            <AddBookingCancellationReason
              id={refId}
              onClose={() => getData()}
              open={open}
              setOpen={setOpen}
            />
          )}
          showPagination
          showAddButton
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
        />
      )}
    </>
  );
};


export default BookingCancellationReasons;
